import React from 'react';
import { Select } from 'releox-react';
import { teamOptions } from '../../options';

export default () => (
  <>
    <Select name="team" label="Team" options={teamOptions} />
  </>
);
